import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterFull } from "../../../components/FooterFull";

import {
  Screen1,
  Screen2
} from "../../../components/LandingTemplates/irregular_verbs";
const TITLE = 'Запись тренинга Запоминание неправильных глаголов';
const DESCRIPTION = 'Запись тренинга Запоминание неправильных глаголов';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  { widget=(<GetCourseWidget hash={'8b52a15325b5190cce1a6b68675ba1f2e2edcdff'} id={'308831'} />) }
) => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main style={{ fontFamily: `"Muller", sans-serif`, color: "#353535" }}>
      <Screen1 widget={widget}/>
      <Screen2 widget={widget}/>
    </main>

    <FooterFull/>
  </DefaultLayout>
);
export default Page;
